import { Button, Link } from "@chakra-ui/react";

import { useNamespace } from "~/hooks";

const SupportButton = () => {
  const { translate } = useNamespace("contact");

  return (
    <Button
      as={Link}
      variant="terciary"
      href="https://help.fluency.io/"
      zIndex="tooltip"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap="9px"
      color="#FFF"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
        <path
          d="M12.2344 11.7435C12.2344 10.9812 11.5618 10.3086 10.7995 10.3086H10.082C8.46777 10.3086 7.21224 11.609 7.21224 13.1784V15.3307C7.21224 16.945 8.46777 18.2005 10.082 18.2005H10.7995C11.5618 18.2005 12.2344 17.5728 12.2344 16.7656V11.7435ZM20.1263 18.2005C21.6957 18.2005 22.9961 16.945 22.9961 15.3307V13.1784C22.9961 11.609 21.6957 10.3086 20.1263 10.3086H19.4089C18.6017 10.3086 17.974 10.9812 17.974 11.7435V16.7656C17.974 17.5728 18.6017 18.2005 19.4089 18.2005H20.1263ZM15.1042 2.41667C8.69198 2.41667 3.80436 7.75269 3.625 13.8958V14.6133C3.625 15.0168 3.93888 15.3307 4.34245 15.3307H5.0599C5.41862 15.3307 5.77734 15.0168 5.77734 14.6133V13.8958C5.77734 8.78402 9.94751 4.56901 15.1042 4.56901C20.216 4.56901 24.431 8.78402 24.431 13.8958H24.3862C24.3862 14.0304 24.431 21.3394 24.431 21.3394C24.431 22.4155 23.579 23.2227 22.5028 23.2227H17.974C17.974 22.0568 16.9875 21.0703 15.8216 21.0703H14.3867C13.176 21.0703 12.2344 22.0568 12.2344 23.2227C12.2344 24.4333 13.176 25.375 14.3867 25.375H22.5028C24.7449 25.375 26.5833 23.5814 26.5833 21.3394V13.8958C26.3591 7.75269 21.4715 2.41667 15.1042 2.41667Z"
          fill="currentColor"
        />
      </svg>
      {translate("contact@help")}
    </Button>
  );
};

export default SupportButton;
